<section
  class="cmn-innerpage-wrapper quotation-details"
>
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button
      class="cmn-add-btn"
      (click)="navigateTo('/quotation/quotation-new')"
      *ngIf="canCreateQuotation$ | async"
    >
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New
      Quotation
    </button>
  </div>
  <div class="sub-head">
    <div class="flex-sub-head">
      <ul>
        <li class="main">All Quotes</li>
        <li
          class="edit"
          *ngIf="(selectedQuote?.quoteStatus === 'Draft' || selectedQuote?.quoteStatus === 'Pending') && (canEditQuotation$ | async)"
          (click)="navigateToEdit(selectedQuote?.id)"
        >
            <img src="assets/images/icons/icon-edit-accounts.svg" alt="Edit" />
            Edit
        </li>

        <!-- generated quote pdf -->
        <li
          class="edit"
          (click)="onViewDocument()"
          [ngClass]="{ 'loading-cursor': pdfLoading }"
        >
          <img src="assets/images/icons/icon-pdf.svg" alt="PDF" />
          PDF
        </li>
      </ul>


      <div class="branch-wrapper">
        <form>
          <mat-form-field>
            <mat-select
              [(value)]="matchedQuote"
              (selectionChange)="onQuoteSelectionChange($event.value)"
              [placeholder]="
                quoteDropdown?.length > 0
                  ? 'Select quote'
                  : 'No quotes available'
              "
            >
              <mat-option
                *ngFor="let quote of quoteDropdown"
                [value]="quote"
              >
                {{ quote.quoteCode || "--" }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div class="mat-menu-wrapper">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button
          mat-menu-item
          type="button"
          *ngIf="
          selectedQuote?.quoteStatus === 'Approved'"
          (click)="confirmSent()"
        >
          <span>Mark as Sent</span>
        </button>
        <button
          mat-menu-item
          type="button"
          *ngIf="
          selectedQuote?.quoteStatus === 'Pending'"
          (click)="confirmReject()"
        >
          <span>Reject Quote</span>
        </button>
        <button
          mat-menu-item
          type="button"
          (click)="quoteRevision()"
          *ngIf="
          (selectedQuote?.quoteStatus === 'Approved' || selectedQuote?.quoteStatus === 'Rejected' || selectedQuote?.quoteStatus === 'Accepted' )&& (canReviseQuotation$ | async)
        "
        >
          <span>Revision</span>
        </button>
       
        <span *ngIf="parentQuoteStatus === 'Draft' && (canDeleteQuotation$ | async)">
          <button
            mat-menu-item
            type="button"
          >
            <span (click)="onDeleteQuoteById(selectedQuote?.id)">Delete</span>
          </button>
        </span>
      </mat-menu>
    </div>
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          *ngFor="let quote of allParentQuotes; let i = index"
          class="tab-custom-button"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>{{ quote.quoteCode }}</h2>
          </div>
          <div class="inn-box">
            <h6>{{ quote.quoteDate | date : "dd MMM yyyy" }}</h6>
            <h5>{{ quote?.projectName }}</h5>
            <!-- <h5>{{ parentQuote?.totalAmount }}</h5> -->
          </div>
          <div class="inn-box">
            <h4
              [ngClass]="{
              'blue': quote?.quoteStatus === 'Open',
              'grey': quote?.quoteStatus === 'Draft',
              'green': quote?.quoteStatus === 'Confirmed',
            }"
            >
              {{ quote?.quoteStatus || "---" }}
            </h4>
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div *ngIf="selectedQuote">
        <div class="chart-tab-content">
          <div class="tab-main-container">
            <div class="tab-inner">
              <div class="note-header">
                <div class="left-set">
                  <h4>To,</h4>
                  <br />
                  <h4>{{ parentQuoteData?.customerData?.firstName + " " + parentQuoteData?.customerData?.lastName }}</h4>
                  <h3 *ngIf="selectedQuote?.billingAddressData?.attention">
                    {{ selectedQuote?.billingAddressData?.attention }}
                  </h3>
                  <h3 *ngIf="selectedQuote?.billingAddressData?.addressLine1">
                    {{ selectedQuote?.billingAddressData?.addressLine1 }}
                  </h3>
                  <h3 class="h3-bottom">
                    {{ selectedQuote?.billingAddressData?.state }}
                    <span
                      *ngIf="
                        selectedQuote?.billingAddressData?.state &&
                        selectedQuote?.billingAddressData?.country
                      "
                      >,</span
                    >
                    {{ selectedQuote?.billingAddressData?.country }}
                  </h3>
                </div>
                <div class="right-set">
                  <h2>QUOTE</h2>
                  <h3>
                    Ref No.: <b>{{ selectedQuote.quoteCode }}</b>
                  </h3>
                  <h3>{{ selectedQuote.quoteDate | date : "dd MMM yyyy" }}</h3>
                </div>
              </div>

              <div class="crdit-note-page-table">
                <table>
                  <tr>
                    <th>Sl No</th>
                    <th>Service Name</th>
                    <th>Qty</th>
                    <th>Unit</th>
                    <th>Rate</th>
                    <th>ETA</th>
                    <th>Amount</th>
                  </tr>
                  <tr
                    *ngFor="
                      let item of selectedQuote?.quoteItems;
                      let i = index
                    "
                  >
                    <td>{{ i + 1 }}</td>
                    <td>{{ item?.serviceData?.serviceName }}</td>
                    <td>{{ item?.quantity || "--" }}</td>
                    <td>{{ item?.unit || "--" }}</td>
                    <td>
                      {{
                        item?.rate != null
                          ? (item?.rate | number : "1.2-2")
                          : "--"
                      }}
                    </td>
                    <td>{{ item?.quoteServiceTasks[0]?.estimatedTime || "--" }}</td>
                    <td>
                      {{
                        item?.quantity && item?.rate
                          ? (item?.quantity * item?.rate | number : "1.2-2")
                          : "--"
                      }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="page-footer-content">
                <div class="left-set">
                </div>

                <div class="right-set">
                  <div class="details-box">
                    <h4>Total Amount</h4>
                    <h5>:</h5>
                    <h6>
                      AED
                      {{ selectedQuote?.subTotal | number : "1.2-2" }}
                    </h6>
                  </div>
                  <div class="details-box">
                    <h4>Discount(-)</h4>
                    <h5>:</h5>
                    <h6>AED {{ selectedQuote?.discountValue | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>VAT (5%)</h4>
                    <h5>:</h5>
                    <h6>AED {{ selectedQuote?.tax | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>Net Amount</h4>
                    <h5>:</h5>
                    <h6>
                      AED {{ selectedQuote?.totalAmount | number : "1.2-2" }}
                    </h6>
                  </div>
                </div>
              </div>

              <div class="terms-conditions">
                <h4>Notes :</h4>
                <h6>
                  {{ selectedQuote?.notes || "--" }}
                </h6>
              </div>


              <span
                class="published-note"
                *ngIf="selectedQuote?.status === 'DRAFT'"
                ><img src="assets/images/img-draft.svg" alt="canceled"
              /></span>
              <span
                class="published-note"
                *ngIf="selectedQuote?.status === 'ACCEPTED'"
                ><img src="assets/images/img-closed.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="selectedQuote?.status === 'DELETED'"
                ><img src="assets/images/img-cancelled.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="selectedQuote?.status === 'DECLINED'"
                ><img src="assets/images/img-cancelled.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="selectedQuote?.status === 'SENT'"
                ><img src="assets/images/img-issued.svg" alt="Draft"
              /></span>
            </div>
          </div>

          <div class="quotation-footer-wrapper">
            <div
              class="submit-btn-wrapper"
            >
              <ng-container
                *ngIf="selectedQuote?.quoteStatus === 'Pending'"
              >
                <button class="cmn-next-btn" type="button" (click)="openQuotaionApprovalDialog()">
                  Approve
                </button>
              </ng-container>
              <ng-container
                *ngIf="selectedQuote?.quoteStatus === 'Sent'"
              >
                <button class="cmn-next-btn" type="button" (click)="acceptQuotation()">
                  Accept
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
